<div [ngClass]="containerClasses" class="px-4 py-2 flex items-center gap-app-size-0-8" data-testid="alert-bar">
	<kendo-svgicon *ngIf="showIcon" [icon]="icon"></kendo-svgicon>
	<p [ngClass]="textClasses" class="text-sm m-0">{{ text }}</p>
</div>
